import type { TFunction } from 'i18next';

// Shared field validators, ported from the identical _validateEmail /
// _validatePassword methods across the auth screens. Return an i18n message
// when invalid, or undefined when the value passes.

export function validateEmail(value: string, t: TFunction): string | undefined {
  const v = value.trim();
  if (v === '') return t('emailRequired');
  if (!v.includes('@') || !v.includes('.')) return t('emailInvalid');
  return undefined;
}

// Password policy — MUST match the GoTrue server policy (Supabase dashboard /
// self-host docker.yaml: min 8 + at least one lower, upper, digit, and symbol).
// Keep this in sync with meetsPasswordPolicy in lib/core/password_policy.dart.
// "Symbol" = any non-alphanumeric, non-whitespace char (cloud's required set is
// the ASCII symbols; this is a close, robust proxy).
export const kPasswordMinLength = 8;

export function meetsPasswordPolicy(value: string): boolean {
  return (
    value.length >= kPasswordMinLength &&
    /[a-z]/.test(value) &&
    /[A-Z]/.test(value) &&
    /[0-9]/.test(value) &&
    /[^A-Za-z0-9\s]/.test(value)
  );
}

// For SETTING a password (sign-up, reset): enforce the full policy.
export function validatePassword(value: string, t: TFunction): string | undefined {
  if (value === '') return t('passwordRequired');
  if (!meetsPasswordPolicy(value)) return t('passwordMin');
  return undefined;
}

// For SIGNING IN: only require non-empty. Existing accounts may predate the
// current policy (e.g. weak passwords created before it was enforced), so the
// client must never block them from typing their real password — the server
// is the authority on whether the credentials are valid.
export function validatePasswordPresent(value: string, t: TFunction): string | undefined {
  if (value === '') return t('passwordRequired');
  return undefined;
}
